import { Path } from "./Path";
import {
  GET_MYAPI_NOT_TOKEN,
  GET_MYAPI_WITH_CREDENTIALS,
  POST_MYAPI_WITH_CREDENTIALS,
} from "./Fetch";

export const Api = {
  _getUser: Path.urlApi + "user",
  _logout: Path.urlApi + "logout",
  _news: Path.urlApi + "news",
};

export const CallApiGetUser = (handleData) => {
  GET_MYAPI_WITH_CREDENTIALS(Api._getUser, async (res) => {
    handleData(res);
  });
};

export const CallApiLogout = (handleData) => {
  POST_MYAPI_WITH_CREDENTIALS(Api._logout, {}, async (res) => {
    handleData(res);
  });
};

export const CallApiGetNews = (param, handleData) => {
  const url = `${Api._news}?type=${param.type}&page=${param.page}&pageSize=${param.pageSize}&searchText=${param.search}`;
  GET_MYAPI_NOT_TOKEN(url, (res) => {
    handleData(res);
  });
};

export const CallApiGetNewById = (id, handleData) => {
  const url = `${Api._news}/${id}`;
  GET_MYAPI_NOT_TOKEN(url, (res) => {
    handleData(res);
  });
};
